import { jwtDecode } from 'jwt-decode'

const decodeToken = (token) => {
  return jwtDecode(token)
}

const getExpirationInMilliseconds = (token) => {
  const decoded = decodeToken(token)
  return decoded?.exp * 10000
}

export const hasTokenExpired = (token) => {
  if (!token) return true

  const expiration = getExpirationInMilliseconds(token)

  if (!expiration) return true

  return Date.now() > expiration
}
